import { CommonModule } from '@angular/common';
import {
	Component,
	EventEmitter,
	inject,
	OnDestroy,
	Output,
} from '@angular/core';
import { PRIMENG_MODULES } from '@shared/primeng';
import { MessageService } from 'primeng/api';
import { Subject } from 'rxjs';
import { ZXingScannerComponent, ZXingScannerModule } from '@zxing/ngx-scanner';
import { Result } from '@zxing/library';

export interface ScannerOutput {
	userId: string;
	type: 'user' | 'coupon';
	couponId?: string;
}

@Component({
	selector: 'app-qr-scanner',
	imports: [CommonModule, ZXingScannerModule, ...PRIMENG_MODULES],
	templateUrl: './qr-scanner.component.html',
	styleUrl: './qr-scanner.component.scss',
})
export class QrScannerComponent implements OnDestroy {
	@Output() public scanned = new EventEmitter<ScannerOutput>();

	private messageService = inject(MessageService);
	private unsubscribe$ = new Subject<void>();

	ngOnDestroy(): void {
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
	}

	public onScanEvent(scanner: ZXingScannerComponent, result: Result): void {
		console.log({ result });

		if (!result) return;

		const resultValue: ScannerOutput = JSON.parse(result.getText());
		scanner.scanStop();

		console.log({ resultValue });

		if (!resultValue.userId) {
			this.scannerErrorNotification(scanner);
			return;
		}

		const userId = resultValue.userId;
		const type = resultValue.type;

		if (!type) {
			this.scannerErrorNotification(scanner);
			return;
		}

		switch (type) {
			case 'user': {
				this.messageService.add({
					severity: 'success',
					summary: 'Código QR escaneado',
					detail: `Usuario: ${userId}`,
				});

				this.scanned.emit({ userId, type });
				break;
			}

			case 'coupon': {
				if (!resultValue.couponId) {
					this.scannerErrorNotification(scanner);
					return;
				}

				const couponId = resultValue.couponId;

				this.scanned.emit({ userId, type, couponId });
				break;
			}

			default: {
				this.scannerErrorNotification(scanner);
				break;
			}
		}
	}

	private scannerErrorNotification(scanner: ZXingScannerComponent) {
		this.messageService.add({
			severity: 'error',
			summary: 'Error',
			detail: 'Código QR inválido, reintente nuevamente',
		});
		scanner.scanStop();
	}
}
